import axios from 'axios';
import Actions from './actions';
import { errorDuck } from '../error';
import _ from "lodash";
import moment from "moment";
import * as UTIL from '../../util';
import { apiUtil } from '../../util';
var Creators = Actions.Creators;
var requestAddWishlist = Creators.requestAdd;
var receiveAddWishlist = Creators.responseAdd;
var requestRemoveWishlist = Creators.requestRemove;
var receiveRemoveWishlist = Creators.responseRemove;
var receiveGet = Creators.receiveGet;
var errorOperations = errorDuck.operations;
var receiveError = errorOperations.receiveError;

function getWishlist(state) {
  return function (dispatch) {
    var _state$location, _state$location$locat, _state$account, _state$account$aadRes;

    var url = apiUtil.API.getWishlist.replace('{storeId}', (_state$location = state.location) === null || _state$location === void 0 ? void 0 : (_state$location$locat = _state$location.location) === null || _state$location$locat === void 0 ? void 0 : _state$location$locat.olo_unique_name);
    var token = (_state$account = state.account) === null || _state$account === void 0 ? void 0 : (_state$account$aadRes = _state$account.aadResponse) === null || _state$account$aadRes === void 0 ? void 0 : _state$account$aadRes.jwtIdToken;
    return UTIL.apiUtil.fetchGet(url, token).then(function (res) {
      dispatch(receiveGet(res));
    }).catch(function (err) {
      console.log('Eror on wishlist request: ', err);
      dispatch(receiveError(UTIL.buildError(err)));
    });
  };
}

function addToWishlist(productId, state) {
  return function (dispatch) {
    var _state$account2, _state$account2$aadRe;

    dispatch(requestAddWishlist());
    var token = (_state$account2 = state.account) === null || _state$account2 === void 0 ? void 0 : (_state$account2$aadRe = _state$account2.aadResponse) === null || _state$account2$aadRe === void 0 ? void 0 : _state$account2$aadRe.jwtIdToken;
    return UTIL.apiUtil.fetchPost(apiUtil.API.addWishlist, {
      "ProductId": productId
    }, token).then(function () {
      dispatch(receiveAddWishlist());
    }).catch(function (err) {
      dispatch(receiveError(UTIL.buildError(err)));
    });
  };
}

function removeFromWishlist(productId) {
  return function (dispatch) {
    dispatch(requestRemoveWishlist());
    return UTIL.apiUtil.fetchDelete(apiUtil.API.removeWishlist, {
      "ProductId": productId
    }).then(function () {
      dispatch(receiveRemoveWishlist());
    }).catch(function (err) {
      dispatch(receiveError(UTIL.buildError(err)));
    });
  };
}

var handleWishlist = function handleWishlist(productId, isAdd) {
  return function (dispatch, getState) {
    isAdd ? dispatch(addToWishlist(productId, getState())) : dispatch(removeFromWishlist(productId));
  };
};

var handleGetWishlist = function handleGetWishlist() {
  return function (dispatch, getState) {
    dispatch(getWishlist(getState()));
  };
};

export default {
  handleWishlist: handleWishlist,
  handleGetWishlist: handleGetWishlist
};